import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSpinner } from '@fortawesome/free-solid-svg-icons/faSpinner';



const LoadingPage = () => {

	return (
		<div className="lfmt-loading loading-page">
			
			<FontAwesomeIcon className="loading-icon fa-spin" icon={faSpinner} />

		</div>
	);
};

export default LoadingPage;